import { TypedEmitter } from 'tiny-typed-emitter'
import { ipc } from './ElectronIPC'
import { IpcRendererEvent } from 'electron'

type WinKeyHookKeys = 'win' | 'tab' | 'g'

type WinKeyHookEventData = {
    keydown?: WinKeyHookKeys
    keyup?: WinKeyHookKeys
}

interface WinKeyHookEvents {
    onkey: (data: WinKeyHookEventData) => void
}

class IpcWinKeyHook extends TypedEmitter<WinKeyHookEvents> {
    constructor() {
        super()

        this.onkeyHandler = this.onkeyHandler.bind(this)

        ipc.on('WinKeyHook.onkey', this.onkeyHandler)
    }

    setEnabled(isEnabled: boolean) {
        ipc.send('WinKeyHook.setEnabled', isEnabled)
    }

    private onkeyHandler(_ev: IpcRendererEvent, data: WinKeyHookEventData) {
        this.emit('onkey', data)
    }

    destructor() {
        ipc.removeListener('WinKeyHook.onkey', this.onkeyHandler)
    }
}

export const winKeyHook = new IpcWinKeyHook()
